import { Trans } from '@lingui/react'
import classNames from 'clsx'
import { arrayOf, func, oneOfType, shape, string } from 'prop-types'
import { PureComponent } from 'react'
import { connectMenu } from 'react-instantsearch-dom'

import {
  FILTER_FLYOUT_CLOSE,
  PRODUCT_FILTER_RESET,
} from 'shared/experiments/components/NewSerp/consts'
import FlyoutFilter from 'shared/experiments/components/NewSerp/FlyoutFilter/FlyoutFilter'
import { withSearchStateHandler } from 'shared/experiments/components/NewSerp/helpers'
import { CategoryListItemType } from 'shared/experiments/components/NewSerp/types'
import store, { subscribe } from 'shared/store'
import IconBin from 'views/components/atoms/Icon/IconBin'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import TextWithIcon from 'views/components/molecules/TextWithIcon'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { publicRuntimeConfigType } from 'views/utils/propTypes'

import CategoryListItem from './CategoryListItem'
import { parseCategories } from './helpers'

import 'views/components/organisms/AlgoliaInstantSearch/Algolia/CategoryList/CategoryList.scss'

class CategoryList extends PureComponent {
  subscriptions = []
  state = {
    currentCategory: this.props.currentRefinement,
  }

  constructor(props) {
    super(props)

    this.subscriptions.push(
      subscribe.after(PRODUCT_FILTER_RESET, this.handleResetClick)
    )
    this.subscriptions.push(
      subscribe.after(FILTER_FLYOUT_CLOSE, payload => {
        if (payload.attribute === this.props.attribute) {
          this.restoreInputValues()
        }
      })
    )
  }

  componentWillUnmount() {
    this.subscriptions.forEach(unsub => unsub())
  }

  /**
   * Restore input values after flyout closing, if they were not applied
   */
  restoreInputValues() {
    const { currentRefinement } = this.props
    const { currentCategory } = this.state

    if (currentCategory !== currentRefinement) {
      this.setState({ currentCategory: currentRefinement })
    }
  }

  handleResetClick = () => {
    this.setState({ currentCategory: '' }, () => {
      withSearchStateHandler(() => this.props.refine(''))
    })
  }

  handleCategoryListItemClick = ({ value }) => {
    this.setState({ currentCategory: value }, () => {
      withSearchStateHandler(() =>
        this.props.refine(this.state.currentCategory)
      )
    })
  }

  handleApplyClick = event => {
    event.preventDefault()
    withSearchStateHandler(() => {
      this.props.refine(this.state.currentCategory)
      store.dispatch({ type: FILTER_FLYOUT_CLOSE })
    })
  }

  render() {
    const { items, attribute, label, currentRefinement } = this.props
    const { currentCategory } = this.state
    const parsedItems = parseCategories({
      items,
      currentCategory,
    })
    const isRefined = Boolean(currentRefinement)
    const shouldRender = Boolean(parsedItems.length)
    const shouldDisableControls = !currentCategory && !isRefined

    return (
      <FlyoutFilter
        attribute={attribute}
        label={label}
        active={isRefined}
        hidden={!shouldRender && !isRefined}
        count={isRefined ? 1 : 0}
      >
        <div className="u-padding@small-tiny u-padding--sides@small-tiny">
          <ul className="e-RefinementList e-RefinementList--horizontalScroll m-CategoryList a-list-reset u-padding--right">
            {parsedItems.map((item, index) => (
              <CategoryListItem
                key={item.value}
                isLast={index + 1 === parsedItems.length}
                onClick={() => this.handleCategoryListItemClick(item)}
                item={item}
              />
            ))}
          </ul>

          <div className="u-margin--top u-padding--top u-border--top e-RefinementList__CategoryList__resetButton--wrapper">
            <ButtonAsLink
              className={classNames('o-RefinementList__resetButton', {
                'u-font-weight--bold': !shouldDisableControls,
              })}
              onClick={this.handleResetClick}
              disabled={shouldDisableControls}
            >
              <TextWithIcon icon={<IconBin size="small" />}>
                <Trans id="searchResults.label.clearFilter" />
              </TextWithIcon>
            </ButtonAsLink>
          </div>
        </div>
      </FlyoutFilter>
    )
  }
}

CategoryList.propTypes = {
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  label: string.isRequired,
  attribute: string.isRequired,
  items: arrayOf(CategoryListItemType).isRequired,
  refine: func.isRequired,
  currentRefinement: oneOfType([string, shape({})]),
}

CategoryList.defaultProps = {
  currentRefinement: null,
}

export default connectMenu(withShopAndRuntimeConfig(CategoryList))
